module.exports = __webpack_public_path__ + "static/media/JP.ae019c37.svg";